import { PageHeader } from '@/modules/common/components/PageHeader';
import { ContractInfoBanner } from '@/modules/onboarding/components/ContractInfoBanner';
import { FinishOnboardingBanner } from '@/modules/onboarding/components/FinishOnboardingBanner';
import { SignTheContractBanner } from '@/modules/onboarding/components/SignTheContractBanner';
import { StripeBanner } from '@/modules/onboarding/components/StripeBanner';

export function EducationProviderSettingsPage() {
  return (
    <div className="flex flex-col h-full text-mydra-black">
      <PageHeader pageTitle="Organization settings" />
      <main className="flex flex-col gap-4 px-8 py-12 @container">
        <StripeBanner />
        <FinishOnboardingBanner />
        <SignTheContractBanner />
        <ContractInfoBanner />
      </main>
    </div>
  );
}
